import { render, staticRenderFns } from "./TimeToCompletion.vue?vue&type=template&id=9347c028&scoped=true&"
import script from "./TimeToCompletion.vue?vue&type=script&lang=js&"
export * from "./TimeToCompletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9347c028",
  null
  
)

export default component.exports